export default {
  shipmentsChart: 'نمودار سفارش‌ها',
  usersChart: 'نمودار کاربران',
  companiesScoreChart: 'نمودار امتیاز باربری ها',
  lineChart: 'نمودار خطی',
  barChart: 'نمودار میله ای',
  load: 'سفارش',
  loadCount: 'تعداد سفارش',
  person: 'نفر',
  userCount: 'تعداد کاربر',
  score: 'امتیاز',
  scoreCount: 'تعداد امتیاز',
  number: 'عدد',
  legal: 'حقوقی',
  real: 'حقیقی',
  companiesShipmentChart: 'نمودار سفارش باربری ها',
  recentlyCreatedCount: 'تعداد کاربران جدید',
  recentlyActiveCount: 'تعداد کاربران فعال',
  recentlySubmittedCount: 'سفارش‌های ثبت شده جدید'
}